import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Stack } from "@mui/system";
import PopupWithButton from "./PopupWithButton";
import { AiFillCloseCircle } from "react-icons/ai";
import "react-slideshow-image/dist/styles.css";
import { Slide } from "react-slideshow-image";
import colors from "../config/colors";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import apiClient from "../api/apiClient";

export default () => {
  const [open, setopen] = useState(false);
  const [current, setCurrent] = useState(null);
  const [menu, setMenu] = useState([]);
  const { isLoggedIn, userType } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    setIsAuthenticated(!!authToken);
  }, []);

  useEffect(() => {
    if (isLoggedIn) handleNavigate(userType);
  }, [isLoggedIn, userType]);

  useEffect(() => {
    document.title = "RollingAdz: Dashboard";
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await apiClient.get("/products/");
      setMenu(response.data);
    } catch (error) {
      console.log("error", error);
      console.error("Error fetching products:", error);
    }
  };

  function handleNavigate(role) {
    if (role == "IN") navigate("/installeraccount");
    else if (role == "PH") navigate("/photograperaccount");
    else if (role == "AC") navigate("/advertiser-account");
    else if (role == "VO") navigate("/vehicleowneraccount");
    else if (role == 5) navigate("/driver-search-result");
  }

  return (
    <div>
      <div className="container-fluid gx-0">
        <div className="row">
          <div className="col">
            <div className="d-md-flex justify-content-md-between bg_header px-3 pb-md-0 pb-3">
              <div className="logo_img_style mx-md-0 mx-auto">
                <img
                  src={require(".././assets/img/MOOH Logo.png")}
                  className="" // Add empty string or remove this line if no class is needed
                  width="70%"
                  alt=""
                />
              </div>
              <Box className="my-auto text-center text-md-start ">
                <Box sx={{ display: { sm: "inline-block", xs: "none" } }}>
                  {/* <Link
                    to={"/agency-packages"}
                    className="btn Request_color fs-4"
                  >
                    Campaign Packages
                  </Link> */}
                </Box>
                {!isAuthenticated && (
                  <Box sx={{ display: { sm: "inline-block", xs: "none" } }}>
                    <Link to={"/signin"}>
                      <button className="btn SignIn_color text-white fs-4 ps-2">
                        Sign in/Sign up
                      </button>
                    </Link>
                  </Box>
                )}
                {isAuthenticated && (
                  <Box sx={{ display: { sm: "inline-block", xs: "none" } }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className="ms-2"
                      onClick={() => navigate("/vehicleowneraccount")}
                    >
                      Go to Dashboard
                    </Button>
                  </Box>
                )}
                {/* <Link to={"/request-comapaign"}>
                  <FaShoppingCart
                    style={{ paddingLeft: "10px" }}
                    color="#0074AC"
                    size={35}
                  />
                </Link> */}
                <div></div>
              </Box>
            </div>
          </div>
        </div>

        <div className="container-fluid row">
          <div className="col-lg-7 col-md-6 map_height">
            <div className="h-100 index_bg my-auto d-flex justify-content-center ">
              <Box sx={{ marginTop: "150px" }}>
                <p className="text-white">Welcome to Moving Out of Home</p>
                <h1 className="text-white">
                  Mobile. Distinctive. Powerful.
                  <br /> Billboards
                </h1>
                {!isAuthenticated && (
                  <Box
                    className="justify-content-center"
                    sx={{ display: { sm: "none", xs: "flex" } }}
                  >
                    <Link to={"/signin"}>
                      <button className="btn SignIn_color text-white fs-4 ps-2">
                        Sign in/Sign up
                      </button>
                    </Link>
                  </Box>
                )}
              </Box>

              {/* <iframe className="w-100 h-100" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d13465.913109294252!2d74.51117165!3d32.45989695000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1674630598202!5m2!1sen!2s" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> */}
            </div>
          </div>

          <div className="col-lg-5 col-md-6 bg_sky">
            <div>
              <div className="Drivers my-2">
                <h5 className="mx-auto">Available Products</h5>
              </div>
            </div>
            <div className="row allContacts  reight_side_height">
              {menu.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    if (item.is_clickable) {
                      setCurrent(item);
                      setopen(true);
                    }
                  }}
                  className={`col-md-6 col-sm-6 px-1 mb-2 ${
                    item.is_clickable ? "cursor-pointer" : ""
                  }`}
                >
                  <div
                    className="card card_border div_posetion rounded-4"
                    style={{ borderRadius: "11px" }}
                  >
                    <img
                      className="card-img-top rounded-top-4"
                      src={item.image1}
                      alt="Card image"
                      style={{ width: "100%", height: "220px  " }}
                    />
                    <div className="photo_button d-flex justify-content-between">
                      <button className="px-3 py-2 rounded-pill bg-dark">
                        <b>{item.type}</b>
                      </button>
                      <div className="my-auto">
                        <i className="text-white bi bi-plus-circle text-primary" />
                      </div>
                    </div>
                    {item.vehicle_info && (
                      <div className=" card-body py-1 px-lg-2 px-md-1 px-2 top_border rounded-bottom-4">
                        <div className="  d-flex mb-1  fw-bold flex-wrap">
                          {item.product_description
                            .split("|")
                            .map((type, index, array) => (
                              <div className="align-items-start" key={index}>
                                <p className="">
                                  {type.trim()}
                                  {index < array.length - 1 && (
                                    <span className="mx-1">|</span>
                                  )}
                                </p>
                              </div>
                            ))}
                        </div>
                        {item.vehicle_info.avg_impression && (
                          <p className=" mb-1 fs_14px">
                            Avg. Impressions:
                            <span className="">
                              {item.vehicle_info.avg_impression.toLocaleString()}
                              /mth
                            </span>
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {current && (
        <>
          {current.type === "other" ? (
            <EventCard open={open} item={current} setopen={setopen} />
          ) : (
            <NewCard open={open} item={current} setopen={setopen} />
          )}
        </>
      )}
    </div>
  );
};

function NewCard({ open, setopen, item }) {
  const navigate = useNavigate();

  return (
    <PopupWithButton
      title=""
      content={
        <div className="">
          <div className="">
            <div className="row">
              <div className=" col-2 d-flex align-items-center justify-content-center">
                <div onClick={() => setopen(false)}>
                  <AiFillCloseCircle size={30} color={colors.primary} />
                </div>
              </div>
              <div className=" col-7 d-flex align-items-center justify-content-center">
                <h4
                  className="text_color text-decoration-underline"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Vehicle: {item.name}
                </h4>
              </div>
              <div className=" col-3 d-flex align-items-center justify-content-end">
                <div style={{ width: "8rem" }}>
                  <img
                    width="100%"
                    src={require("../assets/img/MOOH Logo.png")}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <Slide>
              {[item.image1, item.image2, item.image3].map((image, index) => (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundSize: "cover",
                      height: "340px",
                      backgroundImage: `url(${image})`,
                    }}
                  ></div>
                </div>
              ))}
            </Slide>
          </div>
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Vehicle Info:
            </h5>
            {item.vehicle_info ? (
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Avg.Impression:</h6>
                  <p className="fs_14px">
                    {item.vehicle_info.avg_impression.toLocaleString()}/mth
                  </p>
                  {item.vehicle_info.ad_space && (
                    <div>
                      <h6 className="text-muted">Ad Space</h6>
                      <p className="fs_14px">{item.vehicle_info.ad_space}</p>
                    </div>
                  )}
                  {item.vehicle_info.fuel_type && (
                    <div>
                      <h6 className="text-muted">Fuel Type</h6>
                      <p className="fs_14px">{item.vehicle_info.fuel_type}</p>
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Dimensions:</h6>
                  {item.vehicle_info.dimensions.split(",").map((dim, index) => (
                    <p key={index} className="fs_14px">
                      {dim.trim()}
                    </p>
                  ))}
                </div>
                <div className="col-md-4">
                  <h6 className="text-muted">Sold By:</h6>
                  {item.vehicle_info.sold_by
                    .split(",")
                    .map((subitem, index) => (
                      <div key={index} className="p-1">
                        <input type="checkbox" disabled checked name="" id="" />
                        <label className="fs_14px ps-1" htmlFor="">
                          {subitem.trim()}
                        </label>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <p>No vehicle information available.</p>
            )}
            <h5 className="text_color text-decoration-underline">
              Vehicle KPI's:
            </h5>
            {item.vehicle_kpis ? (
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Best Uses:</h6>
                  {item.vehicle_kpis.best_uses
                    .split(",")
                    .map((subitem, index) => (
                      <p key={index} className="fs_14px m-0">
                        {subitem.trim()}
                      </p>
                    ))}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Local Drivers:</h6>
                  {item.vehicle_kpis.local_drivers
                    .split(",")
                    .map((sub, index) => (
                      <p key={index} className="fs_14px m-0">
                        {sub.trim()}
                      </p>
                    ))}
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Routes:</h6>
                  {item.vehicle_kpis.routes.split(",").map((subitem, index) => (
                    <p key={index} className="fs_14px m-0">
                      {subitem.trim()}
                    </p>
                  ))}
                </div>
              </div>
            ) : (
              <p>No vehicle KPI's available.</p>
            )}

            <h5 className="text_color text-decoration-underline mt-2">
              Drive Time:
            </h5>
            {item.drive_time ? (
              <div className="row">
                <div className="col-md-4">
                  <h6 className="text-muted">Hours:</h6>
                  <p>
                    {item.drive_time.day_start_time} to{" "}
                    {item.drive_time.day_end_time}
                  </p>
                </div>

                <div className="col-md-4">
                  <h6 className="text-muted">Days:</h6>
                  <p className="fs_14px">
                    {item.drive_time.week} days per week
                  </p>
                </div>
                <div className="col-md-4">
                  <h6 className="text-muted">Months:</h6>
                  <p className="fs_14px">
                    {item.drive_time.months} hours per mth
                  </p>
                </div>
              </div>
            ) : (
              <p>No drive time information available.</p>
            )}
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            <div>
              <button
                onClick={() => navigate("/agency-packages")}
                className="btn btn_bg px-4 py-3"
              >
                View Packages
              </button>
            </div>
          </div>
        </div>
      }
      isOpen={open}
      yesName=""
      yesClick={() => {}}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}

function EventCard({ open, setopen, item }) {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  function handleSubmit() {}

  return (
    <>
      <PopupWithButton
        title=""
        content={
          <>
            <div className="row">
              <div
                className="col-2 d-flex align-items-center justify-content-center"
                onClick={() => setopen(false)}
              >
                <AiFillCloseCircle size={30} color={colors.primary} />
              </div>
              <div className=" col-7 d-flex align-items-center justify-content-center">
                {item.id === 4 ? (
                  <h4
                    className="text_color text-decoration-underline"
                    style={{ fontSize: "18px", whiteSpace: "nowrap" }}
                  >
                    {item.name}
                  </h4>
                ) : (
                  <h4
                    className="text_color text-decoration-underline"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {item.name}
                  </h4>
                )}
              </div>
              <div
                className=" col-3 d-flex align-items-center justify-content-end"
                style={{ width: "8rem" }}
              >
                <img
                  width={"100%"}
                  src={require("../assets/img/rolling_roz.png")}
                  alt=""
                />
              </div>
            </div>
            <Stack>
              <Slide>
                {item.Image?.map((image, index) => (
                  <div key={index} className=" each-slide-effect">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundSize: "cover",
                        height: "300px",
                        backgroundImage: `url(${image})`,
                      }}
                    >
                      {/* <span>Slide 1</span> */}
                    </div>
                  </div>
                ))}
              </Slide>
            </Stack>
            <div className="box_bg p-3 border border-secondary rounded mt-2">
              <h5 className="text_color text-decoration-underline">
                Product Description:
              </h5>
              <p>{item.description}</p>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2">
              {/* <div className=" ">
                <input
                  min={0}
                  type="number"
                  className="px-2 py-3"
                  name=""
                  id=""
                  style={{
                    borderRadius: "10px",
                    border: "none",
                    width: "6rem",
                    backgroundColor: "#D0DEE7",
                  }}
                  placeholder="0 Qty"
                />
              </div> */}
              <div>
                <button
                  onClick={() => navigate("/agency-packages")}
                  className="btn btn_bg px-4 py-3"
                >
                  View Packages
                  {/* <FaShoppingCart size={25} style={{ paddingLeft: "5px" }} /> */}
                </button>
              </div>
            </div>
          </>
        }
        isOpen={open}
        // loading={loading}
        yesName=""
        yesClick={handleSubmit}
        cancelName=""
        cancelClick={() => setopen(false)}
      />
    </>
  );
}
